import React, {Component} from 'react'
import proj1 from './Assets/proj1.png'
import proj2 from './Assets/proj2.png'
import proj3 from './Assets/proj3.png'
import './Projects.css'



class Projects extends Component{
    componentDidMount(){
        window.scrollTo(0,0)
    }
    render(){
        return(
            <div className="Projects">
                <div className="Landing_Left ProLan_Left">
                    <p className="About_Title Pro_Title">PROJECTS</p>
                </div>
                <p className="About_Title ProjTitle_mobile">PROJECTS</p>
                <div className="OneProj proj1 contain">
                    <div className="OneProj_Text" data-aos="fade-down-right">
                        <p className="Proj_Title"> 1. Food sufficiency Program:</p>

                        <p className="Proj_Details">We, in partnership with other bodies,
                            have arranged farmers in the four geographical
                            zones of Nigeria into registered cooperative 
                            groups; to teach them modern farming techniques,
                            towards increase agricultural yields, marketing,
                                distribution and storage. 
                        </p>
                    </div>
                    <div className="OneProj_Img" data-aos="fade-down-left">
                        <img src={proj1} />
                    </div>
                </div>

                <div className="OneProj proj2 contain">
                    <div className="OneProj_Text" data-aos="flip-right">
                        <p className="Proj_Title"> 2.	Widows and orphans feeding and welfare program:</p>

                        <p className="Proj_Details">In collaboration with religious bodies,
                            we provide food and clothes to widows 
                            and orphans in communities. 
                        </p>
                    </div>
                    <div className="OneProj_Img" data-aos="flip-down">
                        <img src={proj2} />
                    </div>
                </div>
                <div className="OneProj contain">
                    <div className="OneProj_Text" data-aos="fade-up-right">
                        <p className="Proj_Title">3.Data generation and analysis project:</p>

                        <p className="Proj_Details">We have identify four hundred and forty thousand
                            vulnerable (440,000) individuals across the North,
                                South, East and Western part of Nigeria that needs 
                                help. The data have been analyzed into varieties 
                                of sustainable development micro projects for each 
                                individual. While execution is awaiting funds from 
                                donors presently on sourcing.
                        </p>
                    </div>
                    <div className="OneProj_Img" data-aos="fade-up-left">
                        <img src={proj3} />
                    </div>
                </div>
            </div>
        )
    }
}



export default Projects